/**
 * @desc 更换头像
 */
import { UserEntity, ChangeAvatarForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ChangeUserAvatarParameter = ChangeAvatarForm

const method = 'PUT'
const url = '/auth/user/avatar'

export const changeUserAvatarApi = (
  data?: ChangeUserAvatarParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<UserEntity>({
    method,
    url,
    data,
    ...config
  })
}

changeUserAvatarApi.method = method
changeUserAvatarApi.url = url
